export default "__VITE_ASSET__TC5TrW4L__"